// Validador de nome para clientes do cardapio publico.
// Mantem a mesma regra do backend (database.py: validate_customer_name).
// Aceita: letras (qualquer alfabeto, com acento), espaco, hifen, apostrofo.
// Bloqueia: numeros, emojis, simbolos.

const ALLOWED_NON_LETTER = new Set([" ", "-", "'", "’"]);

export function validateCustomerName(raw) {
  const input = (raw == null ? "" : String(raw)).trim();
  if (!input) return { valid: false, error: "Nome obrigatório" };
  const name = input.replace(/\s+/g, " ");
  if (name.length < 2) return { valid: false, error: "Nome muito curto (mínimo 2 letras)" };
  if (name.length > 60) return { valid: false, error: "Nome muito longo (máximo 60 letras)" };
  // \p{L} = qualquer letra Unicode (acentos OK), \p{N} = digitos, \p{Extended_Pictographic} = emojis
  for (const ch of name) {
    if (ALLOWED_NON_LETTER.has(ch)) continue;
    if (!/\p{L}/u.test(ch)) {
      return { valid: false, error: "Use apenas letras (sem números, emojis ou símbolos)" };
    }
  }
  if (!/\p{L}/u.test(name)) {
    return { valid: false, error: "Nome deve conter letras" };
  }
  return { valid: true, name };
}
